import { render, staticRenderFns } from "./Specialties.html?vue&type=template&id=213c871e&external"
import script from "./Specialties.js?vue&type=script&lang=js&external"
export * from "./Specialties.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports